<template>
    <page-container>
<!--        <template v-slot:header>-->
<!--            <header-main-->
<!--                    :form_open="is_form_open"-->
<!--                    @toggleForm="toggleForm($event)"-->
<!--            ></header-main>-->
        <template v-slot:top>
            <sidebar-main-button></sidebar-main-button>
            <top-nav></top-nav>
        </template>
        <template v-slot:content>
            <router-view></router-view>
        </template>
        <template v-slot:footer>
            <footer-main></footer-main>
        </template>
        <template v-slot:others v-if="is_form_open">
            <sign-in-form v-if="is_form_open"></sign-in-form>
        </template>
    </page-container>
</template>

<script>
    import SidebarMainButton from '../components/Buttons/SidebarMainButton';
    import TopNav from '../components/Menu/TopNav';
    import PageContainer from '../components/Containers/PageContainer';
    import FooterMain from '../components/Footer/FooterMain';
    import SidebarMain from '../components/Sidebars/SidebarMain';
    import SignInForm from "../components/Forms/SignInForm";
    export default {
        name: "Home",
        components: {
            TopNav,
            SidebarMainButton,
            SidebarMain,
            FooterMain,
            PageContainer,
            SignInForm
        },
        data() {
          return {
              is_form_open: false
          }
        },

    };
</script>

<style scoped lang="scss">
</style>
